<div>
    <form [formGroup]="form" class="lg:mt-6" (ngSubmit)="onSubmit()">
        <div class="text-[20px] font-[DMSans] text-[rgba(74,74,74,1)] lg:pt-[0px] pt-[30px] w-full">Get text alerts when you're outbid or when admins share important auction info. Set quiet hours anytime. Email alerts are always sent too.</div>
        <div class="font-semibold text-[18px] text-[rgba(0,0,0,1)] pt-[30px] font-mulish w-full" >Send me a message when:</div>
        <div class="flex items-center ml-[5px] py-[9px] h-[35px]">
            <p-checkbox [binary]="true" size="small" inputId="outbid" formControlName="outbidAlert"/>
            <label for="outbid" class="ml-2 text-[14px] text-[rgba(110,110,110,1)]"> I'm outbid </label>
        </div>
        <div class="flex items-center ml-[5px] py-[9px] h-[35px]">
            <p-checkbox [binary]="true" size="small" inputId="admin-update" formControlName="auctionUpdates"/>
            <label for="admin-update" class="ml-2 text-[14px] text-[rgba(110,110,110,1)]"> There's an important update from the Auction Admin </label>
        </div>
        <div class="text-[16px] text-[rgba(74,74,74,1)] pt-[15px] font-mulish w-full" >Mobile Phone Number</div>
        <div class="grid grid-cols-3 gap-[30px]">
            <div  class="lg:col-span-2 col-span-3">
                <input appInputRestrict="^[0-9\s\-\+\(\)]+$" type="text" inputmode="numeric" pInputText id="phone" placeholder="(619) 123 45 67"  autocomplete="off" class="w-full h-[35px] !text-[14px] mt-3px" formControlName="mobilePhone"/>
                <small class="text-red-500 block min-h-[5px]"
                            [ngClass]="{ 'invisible': !getFieldError('mobilePhone')}">
                            {{ getFieldError('mobilePhone') || '' }}
                        </small>
                <div class="flex items-center">
                    <div class="lg:block hidden inline-flex items-center text-[19px] text-[rgba(0,0,0,1)] mr-[2px] ml-[6px]"><fa-icon [icon]="faInfoCircle" /></div>
                    <div class="inline-flex items-center font-[DMSans] text-[12px] text-[rgba(74,74,74,1)] " >For international mobile numbers, use + and country code (e.g. +61 XXXX-XXXX)</div>
                </div>
            </div>
        </div>
        
        
        <div class="font-semibold text-[18px] text-[rgba(0,0,0,1)] pt-[38px] font-mulish w-full" >Text Messages Allowed</div>
        <div class="grid grid-cols-3 md:gap-[30px] mt-3">
            <div class="lg:col-span-1 col-span-3">
                <div class="text-[16px] text-[rgba(74,74,74,1)] pt-[15px] font-mulish w-full" >Start Time</div>
                <p-select [options]="this.startTimes" placeholder="11:00 AM" class="w-full h-[35px] text-[14px] mt-3px items-center" formControlName="startTime"/>
                <small class="text-red-500 block min-h-[5px]"
                            [ngClass]="{ 'invisible': isStartTimeValid()}">
                            {{ startTimeErrorMessage }}
                        </small>
            </div>
            <div class="lg:col-span-1 col-span-3 mb-4 md:mb-0">
                <div class="text-[16px] text-[rgba(74,74,74,1)] pt-[5px] md:pt-[15px] font-mulish w-full " >End Time</div>
                <p-select [options]="this.endTimes" placeholder="08:00 PM" class="w-full h-[35px] text-[14px] mt-3px items-center" formControlName="endTime"/>
            </div>
            <div class="lg:col-span-1 col-span-3">
                <div class="text-[16px] text-[rgba(74,74,74,1)] pt-[10px] font-mulish w-full" >Time Zone</div>
                <p-select [options]="this.timezones" placeholder="US/Eastern" class="w-full h-[35px] text-[14px] mt-3px items-center" formControlName="timezone"/>
            </div>
        </div>
        <div class=" grid grid-cols-3 gap-x-[30px] gap-y-[15px] mt-[30px] flex-wrap-reverse">
            <div class="lg:col-span-1 col-span-3 lg:order-0 order-1">
                <button pButton type="button" [routerLink]="['/my-account']"
                    class="h-[35px] !font-noto-serif w-full"
                    [outlined]="true">
                    Back
                </button>
            </div>
            <div class="lg:col-span-2 col-span-3 lg:order-1 order-0">
                <button pButton 
                    class="h-[35px] !font-noto-serif w-full"
                    type="submit" [disabled]="form.invalid ">
                    Update
                </button>
            </div>
        </div>
    </form>
</div>
